import { render } from "./CollapsingList.vue?vue&type=template&id=fa6e5818&scoped=true&lang=pug"
import script from "./CollapsingList.vue?vue&type=script&lang=js"
export * from "./CollapsingList.vue?vue&type=script&lang=js"

import "./CollapsingList.vue?vue&type=style&index=0&id=fa6e5818&scoped=true&lang=sass"

import exportComponent from "/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa6e5818"]])

export default __exports__